module.exports = __webpack_public_path__ + "static/media/phone.f38e73e9.png";